var _defs, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatternBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 538,
    height: 538,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-51%",
    y: "-51%",
    width: "202%",
    height: "202%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "SourceGraphic"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    filter: "url(#a)",
    cx: 289,
    cy: 412,
    r: 147,
    transform: "translate(-20 -143)",
    fill: "#DB65E2",
    fillRule: "evenodd",
    opacity: 0.476
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternBlur);
export default __webpack_public_path__ + "static/media/pattern-blur.b8e22fd07a55b6f74a4ca317665e73f8.svg";
export { ForwardRef as ReactComponent };